import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const LANGUAGES = [
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
];

export function LanguageProvider({ children }) {
  // Default to Nederlands (Dutch) for Netherlands
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('barber_lang') || 'nl';
  });

  useEffect(() => {
    localStorage.setItem('barber_lang', lang);
  }, [lang]);

  const t = translations[lang] || translations.nl;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
